import { closeConsultation } from '@/api/consultations'
import { useConsultation } from '@/hooks/useConsultation'
import { useLoading } from '@/hooks/useLoading'
import { useUser } from '@/hooks/useUser'

export const useGenerateReport = () => {
  const { showLoading, hideLoading } = useLoading()
  const { updateConsultation } = useConsultation()
  const { user } = useUser()

  return async () => {
    showLoading()

    try {
      updateConsultation(
        await closeConsultation({
          uniqueId: user?.data?.uniqueId as string
        })
      )
    } finally {
      hideLoading()
    }
  }
}
